<div class="container">
  <a [routerLink]="getLink()">
    <circle-progress
      [percent]="progress"
      [radius]="100"
      [showSubtitle]="false"
      [showBackground]="false"
      [showInnerStroke]="false"
      [showZeroOuterStroke]="false"
      [responsive] = "true"
      [animationDuration] = 0
      [unitsFontSize]= 60
      [titleFontSize] = 60
      titleColor = #ffffff
      unitsColor = #ffffff
      outerStrokeColor = #29ff89
    ></circle-progress>
  </a>
</div>
